module.exports = __webpack_public_path__ + "img/acreditacion.78346c18.png";